import React from 'react';
import { TextProps } from '@chakra-ui/react';
import { Text } from 'components/elements/Text';

type Props = Omit<TextProps, 'letterSpacing'> & {
  children?: React.ReactNode;
};

export const Label = ({ children, ...props }: Props) => {
  return (
    <Text className="label" {...props}>
      {children}
    </Text>
  );
};
